const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export function mediaUrl(path) {
  if (!path) return null;
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  return `${BACKEND_URL}${path}`;
}
